import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { ProjectImageBody } from "types/api/projectImage";

function useProjectImageApi() {
    const { del, post, put } = useHttpManaged();
    const createProjectImage = React.useCallback((body: ProjectImageBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, ProjectImageBody, ResponseWithId>({
            url: "/project-image",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateProjectImage = React.useCallback((pathParams: PathParamsWithId, body: ProjectImageBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, ProjectImageBody, null>({
            url: "/project-image/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteProjectImage = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/project-image/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        createProjectImage,
        updateProjectImage,
        deleteProjectImage
    };
}

export default useProjectImageApi;